import { createFileRoute } from '@tanstack/react-router'
import { RoleList } from '@/features/authorization/index.ts'
import { roleListPersistence } from '@/features/authorization/role-list-search.ts'

export const Route = createFileRoute('/_authenticated/system-management/roles/')({
  validateSearch: roleListPersistence.validateSearch,
  beforeLoad: (options) => roleListPersistence.restore(options),
  component: RoleList
})
